import { useParams } from 'react-router'

import { useEntityProfileTabsActiveTab } from '../../../Entity'

import { getUserProfileTabUrl } from './useUserProfileTabsActiveTab.utils'

export function useUserProfileTabsActiveTab({
  getProfileTabUrl = getUserProfileTabUrl,
  preparedTabs,
  userData,
}) {
  const { inhabitantId } = useParams()

  function getTabUrl(tab) {
    return getProfileTabUrl({ tab, userId: inhabitantId })
  }

  return useEntityProfileTabsActiveTab({
    getTabUrl,
    isEntityLoaded: Boolean(userData),
    preparedTabs,
  })
}
